import React, { useContext, useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper';
import { CommonInput, CommonModal, CommonTextarea, CommonDatePicker } from 'components'
import moment from 'moment';
import StorageService from 'utils/StorageServices/StorageServices';
import toast, { Toaster } from 'react-hot-toast';
import { createMaterialCategory } from '_services/materialServices/materialCategoryServices';
import { podReceivedData, updateLrProcess, uploadFiles } from '_services';
import { RiAddLargeFill } from "react-icons/ri";
import { UserContext } from 'context';
import * as Yup from "yup";
import { IoCloseCircle } from 'react-icons/io5';
import { MdOutlineFileDownload, MdOutlineFileUpload, MdOutlineRemoveRedEye } from 'react-icons/md';
import { FaRegImage } from 'react-icons/fa6';
import { RxCross2 } from 'react-icons/rx';
import { BsFiletypeXlsx, BsFillFileEarmarkPdfFill } from 'react-icons/bs';
import ImagePreview from 'modals/LrDetailModal/ImagePreview';

const formObj = {
    company_id: '',
    lr_id: '',
    date: new Date(),
    pod_number: '',
    notes: '',
    file: [],
}

const EditPodStatus = (props) => {
    const { masterData } = useContext(UserContext)
    const { isOpen, closeModal, nextModal, consignorPermissions, deleteImage } = props;
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    const [imagePreview, setImagePreview] = useState({})

    const addPodReceviedSchema = () => {
        return Yup.object().shape({
            date: Yup.string().required("This filed is Required"),
            file: (consignorPermissions?.permission_at_pod?.attachment?.view === 1 &&
                consignorPermissions?.permission_at_pod?.attachment?.mandatory === 1) ?
                Yup.array()
                    .of(
                        Yup.object().shape({
                            path: Yup.string().required("This filed is Required"),
                        })
                    )
                    .min(1, "At least 1 Attachement Required")
                :
                Yup.array().notRequired(),
            pod_number:
                consignorPermissions?.permission_at_pod?.pod_number?.view === 1 &&
                    consignorPermissions?.permission_at_pod?.pod_number?.mandatory === 1
                    ? Yup.string().min(consignorPermissions?.permission_at_pod?.pod_number?.min ? consignorPermissions?.permission_at_pod?.pod_number?.min : 8, `Must be more than ${consignorPermissions?.permission_at_pod?.pod_number?.min} digit `).max(consignorPermissions?.permission_at_pod?.pod_number?.max ? consignorPermissions?.permission_at_pod?.pod_number?.max : 12, `Must be less than ${consignorPermissions?.permission_at_pod?.pod_number?.max}`).required("Required * ")
                    : Yup.string().notRequired(),
        });
    };

    const schema = addPodReceviedSchema();

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, schema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const handleClick = async (value) => {
        const validationResult = await utils?.checkFormError(formValue, schema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            nextModal(formValue)
            closeModal(false);
            setFormError("");
        } else {
            setFormError(validationResult);
        }
    }

    useEffect(() => {
        if (isOpen) {
            setFormValue((s) => ({
                ...s,
                lr_id: isOpen?._id,
                company_id: isOpen?.company_id,
                date: moment(isOpen?.pod_date).hours(16).minutes(30).toDate(),
                pod_number: isOpen?.pod_number,
                notes: isOpen?.pod_remark,
                file: isOpen?.pod_file,
            }))
        }
    }, [isOpen])

    const handleFileChange = async (e) => {
        if (e?.target?.files[0]?.type === "application/pdf" || e?.target?.files[0]?.type.startsWith("image/")) {
            setLoading(true);
            try {
                const formData = new FormData();
                formData.append("file", e?.target?.files[0]);
                const res = await uploadFiles(formData);
                if (res?.responseCode === 200) {
                    var fileArray = []
                    fileArray.push(...formValue?.file, { filename: res?.data?.filename, path: res?.data?.path });
                    handleOnChange('file', fileArray)
                    // setFormValue((s) => ({ ...s, file: fileArray }));
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
            }
        } else {
            toast.error("Invalid file, choose images and pdf only")
        }
    }

    let inhanceProps = {
        ...props,
        submitTitle: loading ? 'Loading...' : props.submitTitle,
        disabled: loading,
        modalZIndex: imagePreview?.preview && -1,
        onSubmit: handleClick,
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(
                0,
                object.target.maxLength
            );
        }
    };

    const handleDeleteImage = async (item) => {
        let images = [...formValue?.file];
        let newArray = images.filter((el) => el?.path != item?.path)

        deleteImage(item);

        setFormValue((s) => ({
            ...s,
            file: newArray,
        }))
    }

    let storeModelProps = {
        isOpen: imagePreview,
        modalMainClass: '_dashCommon_Modal _mdModal',
        modalTitle: 'Preview',
        submitTitle: 'Preview',
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
        modalZIndex: 999999,
        closeModal: (e) => setImagePreview(false),
    }

    return (
        <div>
            <CommonModal {...inhanceProps}>
                <div className='addItem_body'>
                    <div className='colFlx'>
                        <div className='singleDiv'>
                            {/* <CommonInput
                                type="date"
                                label='POD Received Date & Time * '
                                placeholder='POD Received Date & Time * '
                                name='date'
                                value={formValue.date}
                                focus={!!(typeof formError === "object" && formError?.date)}
                                error={!!(typeof formError === "object") ? formError?.date : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            /> */}
                            <CommonDatePicker
                                label={'POD Received Date & Time * '}
                                name='date'
                                startDate={formValue.date}
                                setStartDate={(date) => handleOnChange('date', date)}
                                error={!!(typeof formError === "object") ? formError?.date : ""}
                            />
                        </div>

                        {consignorPermissions?.permission_at_pod?.pod_number?.view === 1 && (
                            <div className="_divForth">
                                <CommonInput
                                    type={consignorPermissions?.permission_at_pod?.pod_number?.field_type === 2 ? "number" : "text"}
                                    label={
                                        consignorPermissions?.permission_at_pod?.pod_number?.mandatory === 1
                                            ? consignorPermissions?.permission_at_pod?.pod_number?.field_name
                                                ? `${consignorPermissions?.permission_at_pod?.pod_number?.field_name} *`
                                                : "POD Number *"
                                            : consignorPermissions?.permission_at_pod?.pod_number?.field_name
                                                ? `${consignorPermissions?.permission_at_pod?.pod_number?.field_name}`
                                                : "POD Number "
                                    }
                                    placeholder={
                                        consignorPermissions?.permission_at_pod?.pod_number?.mandatory === 1
                                            ? consignorPermissions?.permission_at_pod?.pod_number?.field_name
                                                ? `${consignorPermissions?.permission_at_pod?.pod_number?.field_name} *`
                                                : "POD Number *"
                                            : consignorPermissions?.permission_at_pod?.pod_number?.field_name
                                                ? `${consignorPermissions?.permission_at_pod?.pod_number?.field_name}`
                                                : "POD Number "
                                    }
                                    min={consignorPermissions?.permission_at_pod?.pod_number?.min ? consignorPermissions?.permission_at_pod?.pod_number?.min : ""}
                                    max={consignorPermissions?.permission_at_pod?.pod_number?.max ? consignorPermissions?.permission_at_pod?.pod_number?.max : ""}
                                    maxLength={
                                        consignorPermissions?.permission_at_pod?.pod_number?.max
                                            ? consignorPermissions?.permission_at_pod?.pod_number?.max
                                            : "12"
                                    }
                                    onInput={maxLengthCheck}
                                    name="pod_number"
                                    value={formValue.pod_number}
                                    // disabled={consignorPermissions?.permission_at_pod?.pod_number?.view === 1 && consignorPermissions?.permission_at_pod?.pod_number?.mandatory !== 1}
                                    focus={
                                        !!(
                                            typeof formError === "object" &&
                                            formError?.pod_number
                                        )
                                    }
                                    error={
                                        !!(typeof formError === "object")
                                            ? formError?.pod_number
                                            : ""
                                    }
                                    onChange={({ target: { name, value } }) =>
                                        handleOnChange(name, value)
                                    }
                                />
                            </div>
                        )}

                        <div className='singleDiv'>
                            <CommonTextarea
                                type="textarea"
                                label="Notes "
                                placeholder="Notes "
                                name='notes'
                                maxLength="500"
                                onInput={utils.maxLengthCheck}
                                value={formValue.notes}
                                focus={!!(typeof formError === "object" && formError?.notes)}
                                error={!!(typeof formError === "object") ? formError?.notes : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                        </div>

                        {(consignorPermissions?.permission_at_pod?.attachment?.view === 1) ?
                            < div className='singleDiv'>
                                <div className='_flUpload __podFileUpload'>
                                    <input
                                        type="file"
                                        name='file'
                                        id='_file'
                                        hidden
                                        disabled={loading || formValue?.file?.length >= 5}
                                        onChange={(e) => handleFileChange(e)}
                                    />
                                    <label htmlFor='_file'>
                                        <div className='__uploadIcon'>
                                            <MdOutlineFileUpload />
                                        </div>
                                        <div>
                                            <p>Drag and drop files here, or click to browse</p>
                                            <span>Supports PDF, JPG, PNG files up to 10MB each</span>
                                            <div className='_choseBtn'>Choose File</div>
                                        </div>
                                    </label>
                                </div>
                                {formError?.file && (
                                    <span className="input_drop_error">
                                        {formError?.file}
                                    </span>
                                )}
                            </div> : <></>
                        }
                        {(consignorPermissions?.permission_at_pod?.attachment?.view === 1) &&
                            formValue?.file?.length > 0 &&
                            formValue?.file?.map((el) => {
                                return (
                                    <>
                                        {/* <div className='pos-relative'> */}
                                        {/* <img className='_pdfIcon_sigxe'
                                                                                src={`${masterData?.s3_url}${el?.path}`}
                                                                                alt=""
                                                                            /> */}
                                        {/* <span className='_clDel_icon' onClick={(e) => handleDeleteImage(el)}>
                                                                                <IoCloseCircle />
                                                                            </span> */}
                                        <div className='__upFileDetail'>
                                            <div className='__uplImg'>
                                                {
                                                    el?.path?.split('.')?.at(-1) === 'pdf' ?
                                                        <span className='pdf_clsr-ct'>
                                                            <BsFillFileEarmarkPdfFill />
                                                        </span>
                                                        : (el?.path?.split('.')?.at(-1) === 'xlsx' || el?.path?.split('.')?.at(-1) === 'xls' || el?.path?.split('.')?.at(-1) === 'txt') ?
                                                            <span className='xlsx_clsr-ct'>
                                                                <BsFiletypeXlsx />
                                                            </span> :
                                                            <span className='__uplImg-ct'>
                                                                <FaRegImage />
                                                            </span>
                                                }
                                                <p>{`${el?.filename}`}</p>
                                            </div>
                                            <div className='__uplIcons _avPointer'>

                                                <MdOutlineRemoveRedEye onClick={() => setImagePreview({ url: `${masterData?.s3_url}${el?.path}`, preview: true })} style={{ fontSize: '18px', color: 'blue' }} />

                                                <a href={`${masterData?.s3_url}${el?.path}`} target='_blank' className='__upDownload_ico' style={{ fontSize: '18px' }}>
                                                    <MdOutlineFileDownload />
                                                </a>
                                                <span className='__upCross_ico' style={{ fontSize: '18px' }} onClick={(e) => handleDeleteImage(el)}>
                                                    <RxCross2 />
                                                </span>
                                            </div>
                                        </div>
                                        {/* </div> */}
                                    </>
                                )
                            })
                        }

                        {/* {(consignorPermissions?.permission_at_pod?.attachment?.view === 1 &&
                            consignorPermissions?.permission_at_pod?.attachment?.mandatory === 1) ?
                            <div className='singleDiv'>
                                <div className='_flUpload'>
                                    <input
                                        type="file"
                                        name='file'
                                        id='_file'
                                        hidden
                                        disabled={loading || formValue?.file?.length >= 5}
                                        onChange={(e) => handleFileChange(e)}
                                    />
                                    <label htmlFor='_file'>+</label>
                                </div>
                                {formError?.file && (
                                    <span className="input_drop_error">
                                        {formError?.file}
                                    </span>
                                )}
                            </div> : <></>
                        }
                        {(consignorPermissions?.permission_at_pod?.attachment?.view === 1) &&
                            <div className='img_fnex_src'>
                                {
                                    formValue?.file?.length > 0 &&
                                    formValue?.file?.map((el) => {
                                        return (
                                            <>
                                                <div className='pos-relative'>
                                                    <img className='_pdfIcon_sigxe'
                                                        src={`${masterData?.s3_url}${el?.path}`}
                                                        alt=""
                                                    />
                                                    <span className='_clDel_icon' onClick={(e) => handleDeleteImage(el)}>
                                                        <IoCloseCircle />
                                                    </span>
                                                </div>
                                            </>
                                        )
                                    })
                                }
                            </div>
                        } */}
                    </div>
                </div>
            </CommonModal>
            <div className='offBack_drop'></div>

            {
                imagePreview?.preview
                && (
                    <ImagePreview {...storeModelProps} />
                )
            }
        </div>
    )
}

export default EditPodStatus
